import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-play\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-play</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-play_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-play_icon-play\">\n            <path d=\"M17.59,10.344881 L2.77,18.584881 C2.5966658,18.6782148 2.4500006,18.691548 2.33,18.624881 C2.2099994,18.558214 2.15,18.424882 2.15,18.224881 L2.15,1.78488098 C2.15,1.59821338 2.2099994,1.46488138 2.33,1.38488098 C2.4500006,1.30488058 2.5966658,1.31821378 2.77,1.42488098 L17.59,9.66488098 C17.7633342,9.75821478 17.85,9.87154698 17.85,10.004881 C17.85,10.138215 17.7633342,10.2515472 17.59,10.344881 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sprites/icon-play.svg
// module id = y8aU
// module chunks = 1